<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            id="gridContainer"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="true"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'shift-grid-state', savingTimeout: 0 }"
            (onRowDblClick)="onRowDblClick($event)"
            (onExporting)="onExporting($event)"
            keyExpr="id"
            width="100%"
        >
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Shifts</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    showText="inMenu"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{
                    text: 'Reset',
                    icon: 'restore',
                    onClick: resetGrid,
                    stylingMode: 'text'
                }"
                ></dxi-item>
                <!-- Separator -->
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <!-- Separator -->
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="never">
                    <dx-button
                        class="ms-sm-2"
                        text="New Shift"
                        icon="plus"
                        type="default"
                        stylingMode="contained"
                        (onClick)="addShift()"
                    ></dx-button>
                </dxi-item>
            </dxo-toolbar>
            <dxi-column
                [dataField]="gridFieldName('shiftType')"
                [lookup]="{ dataSource: shiftTypeOptions, valueExpr: 'value', displayExpr: 'text' }"
                caption="Shift"
                [filterOperations]="['=']"
                [headerFilter]="{ dataSource: shiftTypeOptions }"
                [minWidth]="150"
            ></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('code')"
                caption="Code"
                [minWidth]="100"
            ></dxi-column>
            <dxi-column
                [allowSorting]="false"
                [allowFiltering]="false"
                [dataField]="gridFieldName('days')"
                caption="Days"
                cellTemplate="days"
                [minWidth]="200"
            ></dxi-column>
            <dxi-column
                [allowFiltering]="false"
                [allowSorting]="true"
                [dataField]="gridFieldName('shiftStart')"
                caption="Hours"
                cellTemplate="hours"
                [minWidth]="200"
            ></dxi-column>
            <dxi-column dataField="supervisor.name" caption="Supervisor" cellTemplate="supervisor" [minWidth]="300" [calculateFilterExpression]="nameOrEmailFilter"></dxi-column>
            <dxi-column [visible]="false" [dataField]="gridFieldName('premiumRate')" caption="Premium Rate" cellTemplate="premiumRate" [minWidth]="150"></dxi-column>
            <dxi-column [visible]="false" [dataField]="gridFieldName('locked')" caption="Locked" [minWidth]="150"></dxi-column>
            <dxi-column [visible]="false" [dataField]="gridFieldName('hasMealTicked')" caption="Has Meal Ticked" [minWidth]="150"></dxi-column>
            <dxi-column [visible]="false" [dataField]="gridFieldName('showInHuddle')" caption="Show In Huddle" [minWidth]="150"></dxi-column>
            <dxi-column [visible]="false" [dataField]="gridFieldName('showInHuddle')" caption="Show In Huddle" [minWidth]="150"></dxi-column>
            <dxi-column [visible]="false" [dataField]="gridFieldName('created')" caption="Created" [minWidth]="150" dataType="date" sortOrder="desc"></dxi-column>
            <dxi-column type="buttons" caption="Actions">
                <dxi-button text="edit" icon="edit" hint="edit" [onClick]="onEdit"></dxi-button>
                <dxi-button text="delete" icon="trash" hint="delete" [onClick]="onDelete"></dxi-button>
            </dxi-column>

            <div *dxTemplate="let cellInfo of 'supervisor'">
                <user-avatar-email
                    [email]="getCellData(cellInfo).supervisor?.email"
                    [name]="getCellData(cellInfo).supervisor?.name"
                    [avatarUrl]="getCellData(cellInfo).supervisor?.avatarUrl"
                ></user-avatar-email>
            </div>

            <div *dxTemplate="let cellInfo of 'hours'">
                {{ getCellData(cellInfo).shiftStart | toDate | date:'shortTime' }}
                -
                {{ getCellData(cellInfo).shiftEnd | toDate | date:'shortTime' }}
            </div>

            <div *dxTemplate="let cellInfo of 'days'">
                {{ formatDays(getCellData(cellInfo).days) }}
            </div>

            <div *dxTemplate="let cellInfo of 'premiumRate'">
                @if (!cellInfo.value || cellInfo.value === 0) {
                    <span>Base</span>
                }
                @if (cellInfo.value > 0) {
                    <span>+${{ cellInfo.value }}/hour</span>
                }
            </div>
        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item
                [dataField]="filterModelName('shiftType')"
                editorType="dxSelectBox"
                [editorOptions]="{ items: shiftTypeOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Shift', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('code')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Code', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('supervisor')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Supervisor', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
        </dx-form>
    </filter-panel>
    <add-shift-form [(visible)]="isAddShiftPopupOpened" (onSave)="onSave()"></add-shift-form>
    <edit-shift-form [(visible)]="isEditShiftPopupOpened" [shiftId]="shiftId" (onSave)="onSave()"></edit-shift-form>
</div>
